const slugifyPart = (value) => {
  if (!value) return "";
  return String(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
};

export const parseClubIdFromParam = (rawParam) => {
  if (!rawParam) return null;
  const firstChunk = String(rawParam).split("-")[0];
  const parsed = Number.parseInt(firstChunk, 10);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed;
};

export const buildClubPath = (clubId, clubName = "") => {
  const id = Number.parseInt(clubId, 10);
  if (!Number.isFinite(id) || id <= 0) return "/clubs";
  const slug = slugifyPart(clubName);
  return slug ? `/clubs/${id}-${slug}` : `/clubs/${id}`;
};

